import { AmplifyConfig, InterfaceConfig } from "@interfaces/index";
import { ThemeApiStructure } from "@interfaces/theme";

export const localTheme: ThemeApiStructure = {
  id: import.meta.env.VITE_ENV === "PROD" ? "" : "49f931c1-d705-4b02-a710-a5da2e0fdec1",
  name: "santander",
  display_name: "Santander",
  description: "",
  code: "",
  url_site: "",
  url_privacy_notice: "",
  url_terms_and_conditions: "",
  palette: {
    palette: {
      primary: {
        base: "#DED4D4",
        dark: "#222222", // obscuro
        main: "#EC0000", // color 2
        light: "#E2E2E2", // color 1
        accent: "#EC0000", // accents
      },
      components: {},
    },
    interface: {
      navbar: {
        logo: "santander/portal/logos/logo.png",
        logo_width: 142,
        logo_height: 28.5,
      },
      lateral: {
        bg_dark: "#222222",
        bg_light: "#E2E2E2",
        logo_bg_dark: "santander/portal/logos/logo_dark_bg.png",
        text_bg_dark: "#FFFFFF",
        logo_bg_light: "santander/portal/logos/logo.png",
        text_bg_light: "#FFFFFF",
      },
      metadata: {
        title: "Santander",
        favicon: "santander/portal/logos/favicon.ico",
      },
    },
  },
};

export const interfaceConfig: InterfaceConfig = {
  name: "santander",
  home_url: "/solicita_tu_credito",
  aviso_privacidad: import.meta.env.VITE_URL_HOME_LENDIA + "/aviso-de-privacidad",
  terminos_condiciones: import.meta.env.VITE_URL_HOME_LENDIA + "/terminos-y-condiciones",
  interest_rate: 30,
  metadata: {
    title: "Santander",
    description:
      "Santander es una plataforma de crédito para PyMEs que ofrece créditos especializados para PyMEs con tasas competitivas y procesos ágiles. Obtén el financiamiento que tu empresa necesita para crecer.",
    favicon: "santander/portal/logos/favicon.ico",
    ogImage: "https://santander.mx/opengraph-image.png?5ab5b324c6780cbc",
  },
  textos_tofu: {
    pm: {},

    pfae: {
      datos_empresa_pfae: {
        titulo: "Registro de empresa",
        sub_titulo: "Ingresa los datos de la persona física con actividad empresarial",
      },
    },
  },
  maps: {
    api_key:
      import.meta.env.VITE_ENV === "PROD"
        ? "AIzaSyDAtCLTqWu3XTjTC6AT2ZysdXUtL33bAX4"
        : "AIzaSyAPkyPkzcAbvKAageB8UN25PKbzl4stiWc",
  },
  companyNames: ["Lendit Group SAPI de CV"],
  text_accionista_check:
    "Declaro bajo protesta de decir verdad ser el Accionista mayoritario de la empresa mencionada en esta solicitud.",
};

export const amplifyConfig: AmplifyConfig = {
  dev: {
    client: {
      userPoolId: "us-east-1_BeRV6uYmO",
      userPoolClientId: "208j2kkvh8r32d2a9qq926t33f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
  prod: {
    client: {
      userPoolId: "us-east-1_Y0yNT5nH4",
      userPoolClientId: "78ctmcltm4h9r5g3lgie7fl65f",
    },
    guarantee: {
      userPoolId: "",
      userPoolClientId: "",
    },
  },
};
